import ThankYouCard from "./component";

export default ThankYouCard;